module.exports = __webpack_public_path__ + "static/restaurant_leteppanyaki02-16c8f0f9c154c813230f23bc4eba5db8.jpg";